import { axiosApi } from 'shared/api/axios'
import { PaymentEndpoint } from 'entities/payments/api/contants'
import { RefundPaymentRequest } from 'entities/payments/model'

export const refundOrder = async (
    orderId: number,
    body: RefundPaymentRequest,
) => {
    try {
        const response = await axiosApi.post<{ total_refund_amount: string }>(
            PaymentEndpoint.RefundPayment(orderId),
            body,
        )
        return response?.data?.total_refund_amount
    } catch (err) {
        console.error('Ошибка возврата', err)
        return null
    }
}
